import { gql } from "@apollo/client";
import FormDialog from "controls/FormDialog";
import { UNRESTRICTED_SPORTS } from "helpers/constants";
import { useActionFragment } from "hooks/useAction";
import useData from "hooks/useData";
import useIsAdmin from "hooks/useIsAdmin";
import { Plus } from "mdi-material-ui";
import React from "react";

import CompetitionsForm from "./Form";

AddCompetitionDialog.useButtonProps = () => {
  return {
    icon: <Plus />,
    content: "Add Competition",
  };
};

export default function AddCompetitionDialog({ orgId = null, onSubmit, onClose }) {
  const addCompetition = useActionFragment("addCompetition", "competition { id }");
  const [data, dataMeta] = useData(
    gql`
      query AddCompetitionDialogQuery($orgId: ID) {
        org(id: $orgId) {
          id
          allowEncodeHighQualityOutputs
          defaultForNewLeagueAdPreset {
            id
          }
          primarySport
        }
      }
    `,
    { orgId },
  );
  const isAdmin = useIsAdmin();

  const orgSport = data?.org?.primarySport;
  const initialSport =
    isAdmin !== false || !orgSport || UNRESTRICTED_SPORTS.includes(orgSport) ? orgSport : "basketball";

  return (
    <FormDialog
      header="Add Competition"
      loading={dataMeta.loading || isAdmin === undefined}
      onClose={onClose}
      onSubmit={async (formData) => {
        const result = await addCompetition({
          input: formData,
        });
        await onSubmit?.(result.addCompetition.competition);
      }}
    >
      <CompetitionsForm
        competitions={[
          {
            org: orgId && {
              id: orgId,
              allowEncodeHighQualityOutputs: data?.org?.allowEncodeHighQualityOutputs,
              __typename: "Org",
            },
            active: true,
            sport: initialSport,
            adPreset: data?.org?.defaultForNewLeagueAdPreset,
          },
        ]}
      />
    </FormDialog>
  );
}
